<template>
  <input type="float"
         :class="fieldClass"
         :readonly="readonly"
         @input="toFixed(size)"
         v-model="number">
</template>

<script>
  export default {
    name: 'input-float',
    props: {
      name: {
        type: String,
        default: function () {
          return ''
        }
      },
      fieldClass: {
        type: String,
        default: function () {
          return ''
        }
      },
      readonly: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      size: {
        type: Number,
        default: function () {
          return 3
        }
      },
      value: {
        default: 0
      },
      placeholder: {
        type: String,
        default: function () {
          return ''
        }
      }
    },
    data: function () {
      return {
        number: 0
      }
    },
    watch: {
      value: function (val) {
        this.number = val
      }
    },
    methods: {
      toFixed: _.debounce(function () {
        // 값을 입력 받을 때마다 지정된 소수점 자릿수로 값을 가공한다.
        let number = this.number
        const size = this.size
        number = isNaN(parseFloat(number)) ? 0 : number

        // 가공된 값으로 초기화
        this.number = parseFloat(parseFloat(number).toFixed(size))

        // 부모창에 값 전달
        this.$emit('input', this.number)
      }, 300),
    },
    mounted: function () {
      // 부모창에서 전달받은 값을 넣어준다,
      this.number = this.value
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ../common/components/InputFloat.vue